import { cn } from "@omni/utils/styles";
import { Ref } from "react";

type StoreSearchMapComponentProps = {
    ref?: Ref<HTMLDivElement>;
};

const StoreSearchMapComponent = ({ ref }: StoreSearchMapComponentProps) => {
    return (
        <div
            className={cn(
                "tw:rounded-md tw:overflow-hidden tw:h-full tw:bg-grey"
            )}
        >
            <div
                className={cn("tw:h-full")}
                ref={ref}
            />
        </div>
    );
};

export { StoreSearchMapComponent };
